if (!customElements.get('brands-nav-slider')) {
  class BrandsNavSlider extends HTMLElement {
    selectors = {
      swiper: '[data-brands-nav-swiper]',
      scrollbar: '.swiper-scrollbar',
    };
    settings = {
      slidesPerView: 'auto',
      spaceBetween: 4,
      scrollbar: {
        el: this.selectors.scrollbar,
        draggable: true,
      },
      breakpoints: {
        990: {
          spaceBetween: 8,
        },
      },
    };
    slider = undefined;

    constructor() {
      super();
    }

    connectedCallback() {
      this.init();
    }

    init() {
      const swiper = this.querySelector(this.selectors.swiper);
      if (!swiper) return;

      this.slider = new Swiper(swiper, this.settings);
    }
  }
  customElements.define('brands-nav-slider', BrandsNavSlider);
}
